import { Component, TemplateRef } from '@angular/core';
import { LoaderComponent } from '../../../components/layout/loader/loader.component';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { SchoolInformationFormComponent } from '../../../components/school/school-information-form/school-information-form.component';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { licenseListComponent } from "../../../components/license/license-list/license-list.component";
import { licenseFormComponent } from '../../../components/license/license-form/license-form.component';
import { SchoolDetailsComponent } from '../../../components/school/school-details/school-details.component';
@Component({
  selector: 'app-school-detail',
  standalone: true,
  imports: [
    CommonModule,
    SchoolInformationFormComponent,
    LoaderComponent,
    licenseListComponent,
    SchoolDetailsComponent
],
  templateUrl: './school-detail.component.html',
  styleUrl: './school-detail.component.scss'
})
export class SchoolDetailComponent {
}